import React, { useEffect, useState } from "react";
import { useParams, Link, useLocation } from "react-router-dom";
import { CheckCircle2, Truck } from "lucide-react";
import api from "@/lib/api";
import { money } from "@/context/StoreContext";

const PAY_LABEL = { pending: "Pending", payment_initiated: "Payment Initiated", paid: "Paid",
  failed: "Failed", cod_pending: "COD Pending", cod_paid: "COD Paid", cancelled: "Cancelled" };

export default function OrderConfirmation() {
  const { id } = useParams();
  const loc = useLocation();
  const [o, setO] = useState(loc.state?.order || null);
  useEffect(() => { window.scrollTo(0, 0); if (!o) api.get(`/orders/${id}`).then((r) => setO(r.data)).catch(() => {}); }, [id, o]);
  if (!o) return <div className="py-24 text-center text-sharoa-muted">Loading…</div>;

  return (
    <div className="max-w-2xl mx-auto px-4 sm:px-8 py-14 text-center">
      <CheckCircle2 size={54} className="mx-auto text-sharoa-rose" />
      <h1 className="font-serif text-4xl mt-5">ORDER CONFIRMED ♡</h1>
      <p className="text-sharoa-muted mt-2">Thank you for choosing SHAROA.</p>

      <div className="bg-sharoa-ivory p-6 mt-8 text-left">
        <div className="flex justify-between border-b border-sharoa-line pb-3 mb-3">
          <div><p className="text-xs uppercase tracking-widest text-sharoa-muted">Order Number</p><p className="font-mono text-lg">{o.order_number}</p></div>
          <div className="text-right"><p className="text-xs uppercase tracking-widest text-sharoa-muted">Date</p><p className="text-sm">{new Date(o.created_at).toLocaleDateString("en-IN")}</p></div>
        </div>
        <div className="space-y-3 mb-3">
          {o.items.map((it) => (
            <div key={it.sku} className="flex gap-3 text-sm">
              <img src={it.image} alt="" className="w-12 h-16 object-cover bg-white" />
              <div className="flex-1"><p className="font-medium">{it.name}</p><p className="text-xs text-sharoa-muted">{it.size}·{it.color}·Qty {it.quantity}</p></div>
              <span className="font-mono text-xs">{money(it.price * it.quantity)}</span>
            </div>
          ))}
        </div>
        <div className="grid grid-cols-2 gap-2 text-sm border-t border-sharoa-line pt-3">
          <div><p className="text-xs text-sharoa-muted">Payment Method</p><p className="capitalize">{o.payment_method === "cod" ? "Cash on Delivery" : "Online (Razorpay)"}</p></div>
          <div><p className="text-xs text-sharoa-muted">Payment Status</p><p>{PAY_LABEL[o.payment_status] || o.payment_status}</p></div>
          <div><p className="text-xs text-sharoa-muted">Total</p><p className="font-mono">{money(o.total)}</p></div>
          <div><p className="text-xs text-sharoa-muted">Est. Delivery</p><p className="flex items-center gap-1"><Truck size={13} /> {o.estimated_delivery}</p></div>
        </div>
        <div className="border-t border-sharoa-line pt-3 mt-3 text-sm">
          <p className="text-xs text-sharoa-muted">Delivery Address</p>
          <p>{o.address?.name}, {o.address?.house}, {o.address?.street}, {o.address?.area} {o.address?.city}, {o.address?.state} — {o.address?.pincode}</p>
        </div>
      </div>

      <div className="flex flex-col sm:flex-row gap-3 mt-7">
        <Link to={`/track-order?order=${o.order_number}`} className="flex-1 bg-sharoa-rose text-white text-xs uppercase tracking-widest py-4">Track My Order</Link>
        <Link to="/shop" className="flex-1 border border-sharoa-charcoal text-xs uppercase tracking-widest py-4">Continue Shopping</Link>
      </div>
    </div>
  );
}
